// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"179":"02b55565","360":"f43393b9","453":"72355522","928":"227a0ab6"}[chunkId] + ".chunk.js";
};